export const LARGE_LAYOUT_BREAKPOINT = 'gt-md';
export const MEDIUM_LAYOUT_BREAKPOINT = 'gt-sm';
export const SMALL_LAYOUT_BREAKPOINT = 'lt-md';
